// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__22klQ","title":"BackImages_title__3aJC9","images":"BackImages_images__3efyw"};